<template>
  <div class="container">
    <div class="contenn" v-html="bannerLIst.content"></div>
    <div class="downFile" v-for="(item, index) in downFileList" :key="index">
      <a :href="item.url" target="_blank">
        <div class="downFiles">
          {{ item.name }}
        </div></a
      >
    </div>
    <div class="cancel" @click="goBack">返回</div>
  </div>
</template>

<script>
import { $get_banner_list } from "@/api";
export default {
  name: "feedbackFile",
  props: {},
  data() {
    return {
      bannerLIst: {}, // 轮播图列表
      downFileList: [],
    };
  },
  components: {},
  created() {},
  async mounted() {
    try {
      let res = await $get_banner_list();
      this.bannerLIst = res.data[this.$route.query.index];
      this.bannerLIst.files.map((item) => {
        this.downFileList.push({ name: item.slice(39), url: item });
      });
    } catch (error) {}
  },
  methods: {
    // downloadImage(imageUrl) {
    //   console.log(111111111);
    //   const xhr = new XMLHttpRequest();
    //   xhr.open("GET", imageUrl, true);
    //   xhr.responseType = "blob";
    //   xhr.setRequestHeader("token", "7e4a3061-3db1-4d76-afec-52ed66df950d");
    //   xhr.withCredentials = true;
    //   xhr.onload = () => {
    //     if (xhr.status === 200) {
    //       const url = window.URL.createObjectURL(xhr.response);
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.download = "image.png";
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //       window.URL.revokeObjectURL(url);
    //     }
    //   };
    //   xhr.send();
    // },
    // 下载文件
    // downloadImage(url, name) {
    //   console.log(11);
    //   var xhr = new XMLHttpRequest();
    //   xhr.open("GET", url, true);
    //   xhr.responseType = "blob";
    //   xhr.onload = function() {
    //     if (xhr.status === 200) {
    //       var urlCreator = window.URL || window.webkitURL;
    //       var imageUrl = urlCreator.createObjectURL(xhr.response);
    //       var tag = document.createElement("a");
    //       tag.href = imageUrl;
    //       tag.download = name;
    //       document.body.appendChild(tag);
    //       tag.click();
    //       document.body.removeChild(tag);
    //     }
    //   };
    //   xhr.send();
    // },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 767px) {
  .container {
    max-width: 1280px;
    height: auto;
    background: #ffffff;
    margin: 16px auto;
    padding: 60px 84px;

    .title {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      text-align: center;
      margin-bottom: 35px;
      cursor: pointer;
    }

    .downFile {
      margin: 20px 0;

      .downFiles {
        color: #0586fb;
        cursor: pointer;
      }
    }

    .cancel {
      margin-top: 90px !important;
      margin: 0px auto;
      width: 193px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 49px;
      text-align: center;
      cursor: pointer;
    }
  }
}

@media (max-width: 767px) {
  .container {
    padding: 30px 16px;
    background: #ffffff;
    margin: 0 auto;
    font-size: 14px;

    .title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 8px;
      text-align: center;
      margin-bottom: 35px;
    }

    .downFile {
      margin: 20px 0;

      .downFiles {
        color: #0586fb;
        cursor: pointer;
      }
    }

    .cancel {
      display: none;
    }
  }
}
</style>
